import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_DOWNLOAD_REPORT_BUTTON = Symbol('download-report-button');
export const TRANSLATION_GROUP_ADMIN_DOWNLOAD_REPORT = Symbol('admin.download-report');
export const TRANSLATION_GROUP_AFFILIATE_DOWNLOAD_REPORT = Symbol('affiliate.download-report');

export const DOWNLOAD_REPORT_LIST_URL = ':namespace/background_reports/list';
export const DOWNLOAD_REPORT_LIST_QUERY_KEY = 'download-report.list';

export const ADMIN_DOWNLOAD_REPORT_LIST_ROUTE_NAME = 'admin.download-report.list';
export const AFFILIATE_DOWNLOAD_REPORT_LIST_ROUTE_NAME = 'affiliate.download-report.list';

export const DOWNLOAD_REPORT_LINK_URL = ':namespace/background_reports/:id/download_report_link';
export const DOWNLOAD_REPORT_LINK_MUTATION_KEY = 'download-report.link';

export const DOWNLOAD_REPORT_DELETE_URL = ':namespace/background_reports/:id';
export const DOWNLOAD_REPORT_DELETE_MUTATION_KEY = 'download-report.delete';

export const DOWNLOAD_REPORT_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.BACKGROUNDREPORTS_SHOW, PermissionsList.affiliate.BACKGROUNDREPORTS_SHOW),
  EDIT: new Permission(PermissionsList.admin.BACKGROUNDREPORTS_EDIT, PermissionsList.affiliate.BACKGROUNDREPORTS_EDIT),
};
